import { useDispatch, useSelector } from 'react-redux';
import './css/dashboard.css';
import './css/app.css';
import './css/main.css';
import './css/common.css';
import './css/payment.css';
import './css/mobile.css';
import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { LoadingModal, MessageModal } from './component/modal/modal';
import { Landmark } from 'lucide-react';
import { changeNum } from './common/function';
import List from './component/list/list';
import Chart from 'react-apexcharts';

import { FreeMode, Pagination, Autoplay, Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleDollarToSlot, faFileCircleCheck } from "@fortawesome/free-solid-svg-icons";

function Dashboard() {
    let dispatch = useDispatch()
    let navigate = useNavigate()

    const swiperRef = useRef(null);

    let MyData = useSelector((state) => { return state.MyData })

    useEffect(() => {
        dispatch(change_Current_Location("대시보드"))
        dispatch(changeHeaderTitle({
            mainTitle: "대시보드",
            subTitle: ""
        }))
    }, [])

    const [balance, setBalance] = useState([])
    const [walletBalance, setWalletBalance] = useState([])

    useEffect(() => {
        WalletBalance()
        Balance();

        const interval = setInterval(() => {
            WalletBalance();
            Balance();
        }, 10000);

        // 클린업 함수
        return () => {
            clearInterval(interval);
        };
    }, [])

    const Balance = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/user-wallet/balance", {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                // console.log(tmp)
                setBalance(tmp?.data?.wallet ?? [])
            } else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const WalletBalance = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/dashboard/info", {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                // console.log(tmp)
                setWalletBalance(tmp?.data ?? [])
            } else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const onClickHistory = () => {
        navigate('/paylist')
    }

    const onClickSearch = () => {

    }

    const ICON = {
        order: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <rect x="4" y="4" width="16" height="16" rx="3" stroke="#16639C" strokeWidth="1.8" />
                <line x1="7" y1="9" x2="17" y2="9" stroke="#16639C" strokeWidth="1.8" strokeLinecap="round" />
                <line x1="7" y1="13" x2="17" y2="13" stroke="#16639C" strokeWidth="1.8" strokeLinecap="round" />
                <line x1="7" y1="17" x2="12" y2="17" stroke="#16639C" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
        ),
        shop: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M5 10h14l-1.2 9H6.2L5 10Z" stroke="#16639C" strokeWidth="1.8" strokeLinejoin="round" />
                <path d="M7 10V6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v4" stroke="#16639C" strokeWidth="1.8" />
                <circle cx="9" cy="14" r="1" fill="#16639C" /><circle cx="15" cy="14" r="1" fill="#16639C" />
            </svg>
        ),
        history: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <rect x="3.5" y="4" width="17" height="14.5" rx="2.5" stroke="#16639C" strokeWidth="1.8" />
                <rect x="6.5" y="7" width="6" height="4" rx="1" stroke="#16639C" strokeWidth="1.8" />
                <line x1="13.5" y1="13" x2="18.5" y2="13" stroke="#16639C" strokeWidth="1.8" strokeLinecap="round" />
                <line x1="13.5" y1="16" x2="18.5" y2="16" stroke="#16639C" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
        ),
        settle: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <rect x="4" y="6" width="16" height="12" rx="2.5" stroke="#16639C" strokeWidth="1.8" />
                <rect x="6.5" y="9" width="6" height="4" rx="1" stroke="#16639C" strokeWidth="1.8" />
                <circle cx="17" cy="15" r="1.6" fill="#16639C" />
            </svg>
        ),
    };

    const items = [
        { key: "order", label: "거래조회", icon: ICON.order, link: "/paylist" },
        { key: "shop", label: "정산내역", icon: ICON.order, link: "/settlement" },
        { key: "shop", label: "입출금내역", icon: ICON.order, link: "/withdraw" },
        { key: "history", label: "URL상품관리", icon: ICON.shop, link: "/urlCreate" },
        { key: "settle", label: "URL결제관리", icon: ICON.order, link: "/urlHistory" },
    ];

    function RefreshIcon(props) {
        return (
            <svg viewBox="0 0 24 24" width={18} height={18} aria-hidden="true" {...props}>
                <path
                    d="M17.65 6.35A7.95 7.95 0 0 0 12 4a8 8 0 1 0 7.9 9.2 1 1 0 0 0-2-.3 6 6 0 1 1-1.55-5.4L15 9h6V3l-2.35 2.35z"
                    fill="currentColor"
                />
            </svg>
        );
    }

    const [open, setOpen] = useState(false);

    const onTransfer = async (amount) => {
        await axios.post(process.env.REACT_APP_API + "/api/user-wallet/withdraw", {
            amount
        }, {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                alert(tmp?.msg);
            } else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    return (
        <div className="flex overflow-hidden">
            {open && (
                <TransferModal
                    currentBalance={balance?.total_balance ?? 0}
                    withdrawable={balance?.available_balance ?? 0}
                    onClose={() => setOpen(false)}
                    onTransfer={(amount) => onTransfer(amount)}
                />
            )}
            <div style={{ margin: "3.5rem auto 0", width: "100%" }}>
                <div className="mobile-dashboard-panel">
                    {/* 상단 환영 영역 */}
                    <div className="mobile-dashboard-welcome">
                        <h1 className="mobile-dashboard-welcome-title">
                            빠른결제대행사
                        </h1>
                        <div className="mobile-dashboard-welcome-sub">
                            <span className="mobile-dashboard-welcome-badge"><Landmark size={14} style={{ marginRight: "3px" }} /> 가맹점 회원</span>
                        </div>
                    </div>

                    {/* 현금잔고 카드 */}
                    <div className="mobile-dashboard-balance-card">
                        <div className="mobile-dashboard-balance-head">
                            <div className="mobile-dashboard-balance-label">현금잔고</div>

                            {/* <button
                                className="mobile-dashboard-refresh-btn"
                                onClick={() => console.log("refresh!")}
                                aria-label="잔고 새로고침"
                            >
                                <RefreshIcon />
                            </button> */}
                        </div>
                        <div className="mobile-dashboard-balance-body">
                            <span className="mobile-dashboard-balance-amount">
                                {changeNum(Number(balance?.total_balance ?? 0))}<span className="unit">원</span>
                            </span>
                            <button
                                style={{
                                    border: "none",
                                    background: "#003050",
                                    color: "#fff",
                                    padding: "6px 12px",
                                    borderRadius: "18px",
                                    fontWeight: 600,
                                    fontSize: "14px",
                                    cursor: "pointer",
                                }}
                                onClick={() => setOpen(true)} // 이벤트 핸들러 연결
                            >
                                이체
                            </button>
                        </div>
                    </div>
                </div>


                <div className="content" id="contents" style={{ marginTop: "0px", paddingLeft: "20px", paddingRight: "20px", paddingTop: "50px" }}>
                    <div className="content-wrap" style={{ paddingBottom: "40px" }}>
                        <div className="content-item"><div className="myMenu">
                            <span className="myMenu-title">마이메뉴</span>

                            <Swiper
                                ref={swiperRef}
                                modules={[FreeMode, Mousewheel]}
                                className="myMenu-swiper"
                                slidesPerView="auto"
                                spaceBetween={10}
                                freeMode={{ enabled: true, momentum: true, momentumBounce: true }}
                                mousewheel={{ forceToAxis: true }}  // 세로 스크롤 간섭 최소화
                                grabCursor={true}
                                slidesOffsetBefore={4}
                                slidesOffsetAfter={4}
                            >
                                {items.map((it) => (
                                    <SwiperSlide key={it.key} className="myMenu-slide">
                                        <Link
                                            to={it.link}
                                            className="myMenu-chip"
                                        >
                                            <div className="myMenu-icon">{it.icon}</div>
                                            <span className="myMenu-label">{it.label}</span>
                                        </Link>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>

                            <div
                                style={{
                                    borderRadius: "14px",
                                    padding: "16px 0px 10px",
                                    width: "100%",
                                }}
                            >
                                {/* 상단 영역 */}
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        marginBottom: "6px",
                                    }}
                                >
                                    {/* 왼쪽: 제목 */}
                                    <span style={{ fontWeight: 600, fontSize: "16px", color: "#444" }}>
                                        매출
                                    </span>

                                    {/* 오른쪽: 조회 버튼 */}
                                    {/* <button
                                        style={{
                                            border: "none",
                                            background: "#003050",
                                            color: "#fff",
                                            padding: "6px 12px",
                                            borderRadius: "18px",
                                            fontWeight: 600,
                                            fontSize: "14px",
                                            cursor: "pointer",
                                        }}
                                        onClick={onClickSearch} // 이벤트 핸들러 연결
                                    >
                                        조회
                                    </button> */}
                                </div>

                                {/* 안내 문구 */}
                                <div style={{ fontSize: "13px", color: "red", lineHeight: 1.4 }}>
                                    표기된 내용은 실금액과 차이가 날 수 있습니다.
                                </div>
                            </div>


                            <div
                                style={{
                                    borderRadius: "14px",
                                    background: "#fff",
                                    padding: "16px 18px",
                                    width: "100%",
                                    boxShadow: "0 2px 10px rgba(0,0,0,.1)",
                                    marginBottom: "10px"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        gap: "16px",
                                    }}
                                >
                                    {/* 왼쪽: 라인 2개 */}
                                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        {/* 금일 매출 */}
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <span style={{ color: "#555", fontSize: 14, fontWeight: "600" }}>금일 매출</span>
                                            <span style={{ color: "#9CA3AF" }}>-</span>
                                            <span style={{ fontWeight: 600, color: "#333" }}>
                                                {changeNum(walletBalance?.today?.today_sales ?? 0)}
                                            </span>
                                            <span style={{ color: "#6B7280" }}>원</span>
                                        </div>

                                        {/* 정산 금액 */}
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <span style={{ color: "#555", fontSize: 14, fontWeight: "600" }}>정산 금액</span>
                                            <span style={{ color: "#9CA3AF" }}>-</span>
                                            <span style={{ fontWeight: 600, color: "#333" }}>
                                                {changeNum(walletBalance?.today?.today_amount ?? 0)}
                                            </span>
                                            <span style={{ color: "#6B7280" }}>원</span>
                                        </div>
                                    </div>

                                    {/* 오른쪽: 내역 버튼(알약) */}
                                    <button
                                        type="button"
                                        style={{
                                            border: "none",
                                            background: "#F3F4F6",
                                            color: "#4B5563",
                                            padding: "8px 14px",
                                            borderRadius: "18px",
                                            fontWeight: 600,
                                            cursor: "pointer",
                                        }}
                                        onClick={onClickHistory} // 필요 시 핸들러 연결
                                    >
                                        내역
                                    </button>
                                </div>
                            </div>
                            <div
                                style={{
                                    borderRadius: "14px",
                                    background: "#fff",
                                    padding: "16px 18px",
                                    width: "100%",
                                    boxShadow: "0 2px 10px rgba(0,0,0,.1)",
                                    marginBottom: "10px"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        gap: "16px",
                                    }}
                                >
                                    {/* 왼쪽: 라인 2개 */}
                                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        {/* 금일 매출 */}
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <span style={{ color: "#555", fontSize: 14, fontWeight: "600" }}>전일 매출</span>
                                            <span style={{ color: "#9CA3AF" }}>-</span>
                                            <span style={{ fontWeight: 600, color: "#333" }}>
                                                {changeNum(walletBalance?.yesterday?.yesterday_sales ?? 0)}
                                            </span>
                                            <span style={{ color: "#6B7280" }}>원</span>
                                        </div>

                                        {/* 정산 금액 */}
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <span style={{ color: "#555", fontSize: 14, fontWeight: "600" }}>정산 금액</span>
                                            <span style={{ color: "#9CA3AF" }}>-</span>
                                            <span style={{ fontWeight: 600, color: "#333" }}>
                                                {changeNum(walletBalance?.yesterday?.yesterday_amount ?? 0)}
                                            </span>
                                            <span style={{ color: "#6B7280" }}>원</span>
                                        </div>
                                    </div>

                                    {/* 오른쪽: 내역 버튼(알약) */}
                                    <button
                                        type="button"
                                        style={{
                                            border: "none",
                                            background: "#F3F4F6",
                                            color: "#4B5563",
                                            padding: "8px 14px",
                                            borderRadius: "18px",
                                            fontWeight: 600,
                                            cursor: "pointer",
                                        }}
                                        onClick={onClickHistory} // 필요 시 핸들러 연결
                                    >
                                        내역
                                    </button>
                                </div>
                            </div>

                            <div
                                style={{
                                    borderRadius: "14px",
                                    background: "#fff",
                                    padding: "16px 18px",
                                    width: "100%",
                                    boxShadow: "0 2px 10px rgba(0,0,0,.1)",
                                    marginBottom: "10px"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        gap: "16px",
                                    }}
                                >
                                    {/* 왼쪽: 라인 2개 */}
                                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        {/* 금일 매출 */}
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <span style={{ color: "#555", fontSize: 14, fontWeight: "600" }}>당월 매출</span>
                                            <span style={{ color: "#9CA3AF" }}>-</span>
                                            <span style={{ fontWeight: 600, color: "#333" }}>
                                                {changeNum(walletBalance?.currentMonth?.current_month_sales ?? 0)}
                                            </span>
                                            <span style={{ color: "#6B7280" }}>원</span>
                                        </div>

                                        {/* 정산 금액 */}
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <span style={{ color: "#555", fontSize: 14, fontWeight: "600" }}>정산 금액</span>
                                            <span style={{ color: "#9CA3AF" }}>-</span>
                                            <span style={{ fontWeight: 600, color: "#333" }}>
                                                {changeNum(walletBalance?.currentMonth?.current_month_amount ?? 0)}
                                            </span>
                                            <span style={{ color: "#6B7280" }}>원</span>
                                        </div>
                                    </div>

                                    {/* 오른쪽: 내역 버튼(알약) */}
                                    <button
                                        type="button"
                                        style={{
                                            border: "none",
                                            background: "#F3F4F6",
                                            color: "#4B5563",
                                            padding: "8px 14px",
                                            borderRadius: "18px",
                                            fontWeight: 600,
                                            cursor: "pointer",
                                        }}
                                        onClick={onClickHistory} // 필요 시 핸들러 연결
                                    >
                                        내역
                                    </button>
                                </div>
                            </div>

                            <div
                                style={{
                                    borderRadius: "14px",
                                    background: "#fff",
                                    padding: "16px 18px",
                                    width: "100%",
                                    boxShadow: "0 2px 10px rgba(0,0,0,.1)",
                                    marginBottom: "10px"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        gap: "16px",
                                    }}
                                >
                                    {/* 왼쪽: 라인 2개 */}
                                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        {/* 금일 매출 */}
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <span style={{ color: "#555", fontSize: 14, fontWeight: "600" }}>전월 매출</span>
                                            <span style={{ color: "#9CA3AF" }}>-</span>
                                            <span style={{ fontWeight: 600, color: "#333" }}>
                                                {changeNum(walletBalance?.lastMonth?.last_month_sales ?? 0)}
                                            </span>
                                            <span style={{ color: "#6B7280" }}>원</span>
                                        </div>

                                        {/* 정산 금액 */}
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <span style={{ color: "#555", fontSize: 14, fontWeight: "600" }}>정산 금액</span>
                                            <span style={{ color: "#9CA3AF" }}>-</span>
                                            <span style={{ fontWeight: 600, color: "#333" }}>
                                                {changeNum(walletBalance?.lastMonth?.last_month_amount ?? 0)}
                                            </span>
                                            <span style={{ color: "#6B7280" }}>원</span>
                                        </div>
                                    </div>

                                    {/* 오른쪽: 내역 버튼(알약) */}
                                    <button
                                        type="button"
                                        style={{
                                            border: "none",
                                            background: "#F3F4F6",
                                            color: "#4B5563",
                                            padding: "8px 14px",
                                            borderRadius: "18px",
                                            fontWeight: 600,
                                            cursor: "pointer",
                                        }}
                                        onClick={onClickHistory} // 필요 시 핸들러 연결
                                    >
                                        내역
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const parseKRW = (s = "") => {
    if (typeof s === "number") return s;
    const digits = String(s).replace(/[^\d]/g, "");
    return digits ? parseInt(digits, 10) : 0;
};

function TransferModal({
    currentBalance,
    withdrawable,
    onClose,
    onTransfer,
}) {
    const [input, setInput] = useState("");    // 입력창 문자열(콤마 포함)
    const amount = useMemo(() => parseKRW(input), [input]);

    const remain = useMemo(
        () => Math.max(0, withdrawable - amount),
        [withdrawable, amount]
    );

    const over = amount > withdrawable;
    const invalid = amount <= 0 || over;

    const handleAll = () => setInput(changeNum(withdrawable));
    const handleChange = (e) => setInput(changeNum(parseKRW(e.target.value)));

    const handleTransfer = useCallback(async () => {
        if (invalid) return;
        try {
            await onTransfer?.(amount);
            onClose();
        } catch (e) {
            // 필요 시 토스트/에러 처리
            console.error(e);
        }
    }, [amount, invalid, onClose, onTransfer]);

    // ESC로 닫기
    useEffect(() => {
        const onKey = (e) => e.key === "Escape" && onClose();
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [onClose]);

    return (
        <div className="modal-backdrop" onClick={onClose}>
            <div
                className="modal-sheet"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby="transfer-title"
            >
                <div className="modal-head">
                    <h2 id="transfer-title">이체</h2>
                    <button className="modal-close" onClick={onClose} aria-label="닫기">✕</button>
                </div>

                <div className="modal-body">
                    <Row label="현재 잔고">
                        <strong>{changeNum(currentBalance)}원</strong>
                    </Row>

                    <Row label="출금가능 잔고">
                        <strong>{changeNum(withdrawable)}원</strong>
                    </Row>

                    <Row label="이체 금액">
                        <div className="amount-input-wrap">
                            <input
                                className="amount-input"
                                inputMode="numeric"
                                placeholder="0"
                                value={input}
                                onChange={handleChange}
                                style={{ width: "120px" }}
                            />
                            <span className="amount-suffix">원</span>
                            <button className="btn-all" onClick={handleAll}>전액</button>
                        </div>
                    </Row>

                    <RowLast label="출금가능 잔액">
                        {over ?
                            <p className="field-error">출금가능 잔고를 초과했습니다.</p>
                            :
                            <strong>{changeNum(remain)}원</strong>
                        }

                    </RowLast>
                </div>

                <div className="modal-foot">
                    <button
                        className={`btn-transfer ${invalid ? "btn-disabled" : ""}`}
                        onClick={handleTransfer}
                        disabled={invalid}
                    >
                        이체
                    </button>
                </div>
            </div>
        </div>
    );
}

function Row({ label, children }) {
    return (
        <div className="row">
            <div className="row-label">{label}</div>
            <div className="row-content">{children}</div>
        </div>
    );
}

function RowLast({ label, children }) {
    return (
        <div className="row" style={{ borderTop: "1px solid #eee", paddingTop: "15px" }}>
            <div className="row-label">{label}</div>
            <div className="row-content">{children}</div>
        </div>
    );
}
export default Dashboard;